import React from "react";
import { Box, Checkbox, FormControlLabel, FormGroup, Typography } from "@mui/material";
import { SelectedFields } from "./types";

interface FieldSelectionProps {
  selectedFields: SelectedFields;
  onChange: (field: keyof SelectedFields, checked: boolean) => void;
}

export const FieldSelection: React.FC<FieldSelectionProps> = ({ selectedFields, onChange }) => {
  return (
    <Box>
      <Typography variant="body1" gutterBottom>
        取得する情報を選択してください
      </Typography>

      {/* Essentials SKU */}
      <Box sx={{ mb: 2 }}>
        <Typography variant="subtitle2" color="text.secondary">
          基本情報（Essentials SKU - 0.005USD）
        </Typography>
        <FormGroup>
          <FormControlLabel
            sx={{ mb: -2 }}
            control={
              <Checkbox
                checked={selectedFields.name}
                onChange={(e) => onChange("name", e.target.checked)}
              />
            }
            label="スポット名 *"
          />
          <FormControlLabel
            sx={{ mb: -2 }}
            control={
              <Checkbox
                checked={selectedFields.formattedAddress}
                onChange={(e) => {
                  // 仕様: 住所チェックボックスは formattedAddress と addressComponents を同時に制御
                  onChange("formattedAddress", e.target.checked);
                  onChange("addressComponents", e.target.checked);
                }}
              />
            }
            label="住所 *"
          />
          <FormControlLabel
            sx={{ mb: -2 }}
            control={
              <Checkbox
                checked={selectedFields.location}
                onChange={(e) => onChange("location", e.target.checked)}
              />
            }
            label="位置情報 *"
          />
          <FormControlLabel
            sx={{ mb: -1 }}
            control={
              <Checkbox
                checked={selectedFields.googleMapsUri}
                onChange={(e) => onChange("googleMapsUri", e.target.checked)}
              />
            }
            label="Google Maps URL（CID抽出） *"
          />
        </FormGroup>
      </Box>

      {/* Contact SKU */}
      <Box sx={{ mb: 2 }}>
        <Typography variant="subtitle2" color="text.secondary">
          連絡先（Contact SKU - 0.017USD）
        </Typography>
        <FormGroup>
          <FormControlLabel
            sx={{ mb: -2 }}
            control={
              <Checkbox
                checked={selectedFields.internationalPhoneNumber}
                onChange={(e) => onChange("internationalPhoneNumber", e.target.checked)}
              />
            }
            label="電話番号"
          />
          <FormControlLabel
            sx={{ mb: -1 }}
            control={
              <Checkbox
                checked={selectedFields.websiteUri}
                onChange={(e) => onChange("websiteUri", e.target.checked)}
              />
            }
            label="ウェブサイト"
          />
        </FormGroup>
      </Box>

      {/* Atmosphere SKU */}
      <Box sx={{ mb: 2 }}>
        <Typography variant="subtitle2" color="text.secondary">
          詳細情報（Atmosphere SKU - 0.025USD）
        </Typography>
        <FormGroup>
          <FormControlLabel
            sx={{ mb: -2 }}
            control={
              <Checkbox
                checked={selectedFields.regularOpeningHours}
                onChange={(e) => onChange("regularOpeningHours", e.target.checked)}
              />
            }
            label="営業時間"
          />
          <FormControlLabel
            sx={{ mb: -2 }}
            control={
              <Checkbox
                checked={selectedFields.rating}
                onChange={(e) => {
                  // 仕様: 評価情報チェックボックスは rating と userRatingCount を同時に制御
                  onChange("rating", e.target.checked);
                  onChange("userRatingCount", e.target.checked);
                }}
              />
            }
            label="評価情報 *"
          />
          <FormControlLabel
            sx={{ mb: -2 }}
            control={
              <Checkbox
                checked={selectedFields.businessStatus}
                onChange={(e) => onChange("businessStatus", e.target.checked)}
              />
            }
            label="営業状態 *"
          />
          <FormControlLabel
            sx={{ mb: -1 }}
            control={
              <Checkbox
                checked={selectedFields.parkingOptions}
                onChange={(e) => onChange("parkingOptions", e.target.checked)}
              />
            }
            label="駐車場情報"
          />
        </FormGroup>
      </Box>
    </Box>
  );
};
